import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

export const AboutLink = (props) => {
  const { className } = props;
  const id = props.id + "-tooltip";
  const { label } = props;

  const tooltip = (
    <Tooltip id={id}>
      <div className='text-start'>{props.children}</div>
    </Tooltip>
  );

  return (
    <>
      <OverlayTrigger key={id} placement='top' overlay={tooltip}>
        <a href='javascript:void(0)'>{label}</a>
      </OverlayTrigger>
    </>
  );
};

// import React from "react";

// export const AboutLink = (props) => {
//   const { className } = props;
//   const id = props.id + "-about-link";

//   return (
//     <>
{
  /* <div className={`text-start ${className}`}>
        <a href='#' id={id}>
          <span>About this chart</span>
          <i className='bi bi-chevron-down ms-2'></i>
        </a>
        <UncontrolledTooltip placement='bottom' target={id}>
          <div className='text-start'>{props.children}</div>
        </UncontrolledTooltip>
      </div> */
}
//     </>
//   );
// };
